<template>
  <fieldset class="m-2">
    <legend class="text-primary text-sm mb-1">{{ legend }}</legend>
    <div class="inline-flex flex-wrap gap-1 rounded bg-gradient-to-br from-gray-100 to-gray-150 shadow-inner p-1">
      <label v-for="option in options" :key="option.id" class="cursor-pointer">
        <input
          type="radio"
          class="sr-only peer"
          :name="name"
          :value="option.id"
          :checked="modelValue === option.id"
          @change="emit('update:modelValue', option.id)"
        >
        <span
          class="block rounded px-3 py-1 text-sm font-medium text-gray-600 transition-colors hover:bg-white/60 peer-checked:bg-white peer-checked:text-primary peer-checked:shadow peer-focus-visible:ring-2 peer-focus-visible:ring-primary"
        >{{ option.label }}</span>
      </label>
    </div>
    <p v-if="hint" class="text-xs text-gray-500 mt-1">{{ hint }}</p>
  </fieldset>
</template>

<script setup>
defineProps({
  legend: { type: String, required: true },
  name: { type: String, required: true },
  options: { type: Array, required: true },
  modelValue: { type: String, default: '' },
  hint: { type: String, default: '' },
});

const emit = defineEmits(['update:modelValue']);
</script>
